import(/* webpackMode: "eager" */ "/srv/app/src/app/global-error.tsx");
